import * as React from 'react'
import { useCallback, useState } from 'react'
import Stack from '@mui/material/Stack'
import { ENTITY_TYPES } from '@sales-center/common'
import { FM_FORM_STATUSES, FormHistoryItem } from '@user/store/agreements'
import { ViewDetailsPopover } from './ViewDetailsPopover/ViewDetailsPopover'
import { ViewDetailsButton } from './atoms/ViewDetailsButton'
import { AgreementActionsButton } from '@user/components/Agreements/common/AgreementActionsButton'

interface Props {
  canUpdate: boolean
  agreementId: number
  entityId: number
  entityType: ENTITY_TYPES
  history: FormHistoryItem[]
  status: FM_FORM_STATUSES
  openAgreementCreateDrawer?: () => void
}

export function ActionsColumn(props: Props) {
  const {
    canUpdate,
    agreementId,
    entityId,
    entityType,
    history,
    status,
    openAgreementCreateDrawer,
  } = props

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handlePopoverOpen = useCallback(
    (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
      setAnchorEl(event.currentTarget)
    },
    [],
  )

  const handlePopoverClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  return (
    <>
      <Stack alignItems="center" direction="row">
        <AgreementActionsButton
          entityId={entityId}
          entityType={entityType}
          id={agreementId}
          status={status}
          canUpdate={canUpdate}
          openAgreementCreateDrawer={openAgreementCreateDrawer}
        />
        <ViewDetailsButton
          onClick={handlePopoverOpen}
          open={Boolean(anchorEl)}
        />
      </Stack>

      <ViewDetailsPopover
        anchorEl={anchorEl}
        history={history}
        agreementId={agreementId}
        onClose={handlePopoverClose}
        open={Boolean(anchorEl)}
      />
    </>
  )
}
